import React from "react";
import { Tag } from "antd";

const { CheckableTag } = Tag;

class CustomTag extends React.Component {
  render() {
    return (
      <CheckableTag
        className="custom-tag custom-tag-mobile-margin"
        {...this.props}
      />
    );
  }
}

export default CustomTag;
